import React from 'react';
import PromptStudio from './components/PromptStudio';
import './index.css'; // asegúrate de tener este import

export default function App() {
  return (
    <>

      <PromptStudio />
    </>
  );
}
